










import { Vue, Component } from 'vue-property-decorator';
import Asignacion from '@/pantallas/Peajes/Asignacion/Asignacion.vue';

@Component({
  components: { Asignacion },
})
export default class AsignacionPantallas extends Vue {}
